import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const pagosPeriodoSlice = createSlice({
  name: 'pagosPeriodo',
  initialState: {
    rows: []
  },
  reducers: {
    setPagosPeriodo: (state, action) => {
      state.rows = action.payload;
    }
  }
});

export const { setPagosPeriodo } = pagosPeriodoSlice.actions;

// Action Creators
export const getPagosPeriodo = (comunidadId, anno, mes) => async (dispatch, getState) => {
  let item = LocalCache.get(`KEY:pagosPeriodo&comunidad=${comunidadId}&ano=${anno}&mes=${mes}`);
  if (item) {
    dispatch(setPagosPeriodo(item));
  } else {
    try {
      const response = await API.get('ePlat', `/pagos-periodo?comunidad=${comunidadId}&ano=${anno}&mes=${mes}`);
      dispatch(setPagosPeriodo(response));
      LocalCache.put(`KEY:pagosPeriodo&comunidad=${comunidadId}&ano=${anno}&mes=${mes}`, response);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getPagosPeriodo()', error);
    }
  }
};

export default pagosPeriodoSlice.reducer;
